import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ModalActions from 'app/actions/ModalActions';
import FlagUgcButton from './FlagUgcButton';

export class FlagUgcButtonContainer extends React.PureComponent {
  render() {
    return <FlagUgcButton {...this.props} />;
  }
}

FlagUgcButtonContainer.propTypes = {
  // ownProps
  id: PropTypes.number.isRequired,
  ugcType: PropTypes.string.isRequired,

  // Redux props
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired
};

const mapDispatchToProps = dispatch => ({
  modalActions: bindActionCreators(ModalActions, dispatch)
});

export default connect(null, mapDispatchToProps)(FlagUgcButtonContainer);
